import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=4bc47e1e&"
import script from "./myTeam.vue?vue&type=script&lang=js&"
export * from "./myTeam.vue?vue&type=script&lang=js&"
import style0 from "./myTeam.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports